<div class="checkout-section-title">
  <h2 class="m-0 d-inline-flex text-b3-m-700 text-md-b1-s-700 text-lg-b1-m-700 color-black">адрес самовывоза</h2>
  <sd-checkout-validation-error [errorKeys]="['PICKUP_ADDRESS_REQUIRED']"></sd-checkout-validation-error>
</div>

<div class="pickup">
  <ng-container [ngSwitch]="state$ | async">
    <ng-container *ngSwitchCase="state.ShowPos">
      <sd-pickup-active-shop></sd-pickup-active-shop>
      <sd-pickup-change-shop-button></sd-pickup-change-shop-button>
    </ng-container>
    <ng-container *ngSwitchCase="state.ShowPosOnlyOne">
      <sd-pickup-info type="success">
        <span>В настоящее время весь заказ вы можете забрать только в этом магазине.</span>
      </sd-pickup-info>
      <sd-pickup-active-shop></sd-pickup-active-shop>
    </ng-container>
    <ng-container *ngSwitchCase="state.ShowPosNotAvailable">
      <sd-pickup-info type="error">
        <span>В выбранном вами магазине доступны не все товары.</span>
      </sd-pickup-info>
      <div class="active-shop-container">
        <sd-pickup-active-shop></sd-pickup-active-shop>
        <sd-pickup-change-shop-button></sd-pickup-change-shop-button>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="state.NoPosAvailable">
      <sd-pickup-info type="warning">
        <span>Сейчас в магазинах доступны не все товары.</span>
        <span>
          Наш менеджер свяжется с Вами после оформления заказа и сориентирует по срокам и наличию товаров в магазинах.
        </span>
      </sd-pickup-info>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <sd-pickup-add-shop text="Выбрать магазин"></sd-pickup-add-shop>
    </ng-container>
  </ng-container>
</div>
